/**
 * JavaScript Utility - string/escapeRegex
 * @author 서명환 <mhseo@ulalalab.com>
 */
function escapeRegex(string = '') {
  // eslint-disable-next-line no-useless-escape
  return string.replace(/([-.*+?\^${}()|\[\]\/\\])/g, '\\$1');
}

export default escapeRegex;
